import { render, staticRenderFns } from "./PartMng.vue?vue&type=template&id=5d12dc93&"
import script from "./PartMng.vue?vue&type=script&lang=js&"
export * from "./PartMng.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports